import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-book-specific-investigations-near-you',
  templateUrl: './book-specific-investigations-near-you.component.html',
  styleUrls: ['./book-specific-investigations-near-you.component.css']
})
export class BookSpecificInvestigationsNearYouComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
  }

}
